import { MainTabsRoutes } from './main-tabs/MainTabsRoutes';
import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth } from '../auth/RequireAuth';
import {
  LoginPage,
  ResetPasswordPage,
  UserSetupPage,
  ForgotPasswordPage,
} from '../pages/auth';
///
export const makeAppRoutes = () => {
  return (
    <>
      <Route path="auth" element={<LoginPage />} />
      <Route path="setup" element={<UserSetupPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route
        path="*"
        element={
          <Suspense>
            <RequireAuth>
              <MainTabsRoutes />
            </RequireAuth>
          </Suspense>
        }
      />
    </>
  );
};
